module.exports = __webpack_public_path__ + "static2023-4-17/img/logo.ca27bf30.png";